<a class="cursor-pointer" [ngClass]="{'slick-active': box}" [routerLink]="'/pacchetti/'+professione.public_token">
    <div class="card post-card">
        <img [src]="getPicture(professione.configuration.image)"
            class="card-img-top" alt="...">
        <div class="card-body">
            <h3><a>{{professione?.name}}</a></h3>
            <p>{{professione?.configuration?.short_description}}</p>
        </div>
    </div>
</a>